import React, { useState } from "react"
import { Controller, useFormContext } from "react-hook-form"
import styled from "styled-components";
import CheckBox from "../CheckBox"
import { ReactComponent as IconError } from "../../../../../assets/images/habitacional/rounded-warning.svg";
import { DefaultParagraphSmallFactory } from "../../Typograph/Typograph.Style";

const ErrorMessage = styled.h6(({ theme }) => ({
    textAlign: "inherit",
    display: "flex",
    alignItems: "center",
    svg: {
        margin: "0 5px 0 0",
        width: "1rem",
    },
    color: theme.color.feedback.error,
    marginTop: 0,
    marginBottom: 0,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "150%",
}));

const InformationForPersonalData = styled.p(({ theme }) => ({
    ...DefaultParagraphSmallFactory({ theme }),
    fontWeight: 400
}))

const CheckBoxComboContainer = styled.div(() => ({
    gap: "8px",
    display: "grid"
}))

const PrivacyPortal = styled.a(({ theme }) => ({
    color: theme.color.brandPrimary.light
}))

const CheckBoxCombo = () => {
    const { control, formState: { errors } } = useFormContext()
    const [awareInformation, setAwareInformation] = useState(false);
    const [correctData, setCorrectData] = useState(false);
    
    return (
        <CheckBoxComboContainer>
            <Controller
                name="CorrectData"
                control={control}
                defaultValue={correctData}
                render={({ field }) => (
                    <CheckBox
                        id="CorrectData"
                        name="CorrectData"
                        text="Li os dados e confirmo que todos estão corretos."
                        checked={correctData}
                        onClick={(e) => {
                            const newValue = e.target.checked;
                            setCorrectData(newValue);
                            field.onChange(newValue);
                        }}
                        {...field}
                    />
                )}
            />
            <Controller
                name="AwareInformation"
                control={control}
                defaultValue={awareInformation}
                render={({ field, }) => (
                    <CheckBox
                        id="AwareInformation"
                        name="AwareInformation"
                        text="Estou ciente que essas informações serão 
                coletadas pela Caixa Seguradora apenas para 
                abertura e tratativas do pedido de indenização."
                        checked={awareInformation}
                        onClick={(e) => {
                            const newValue = e.target.checked;
                            setAwareInformation(newValue);
                            field.onChange(newValue);
                        }}
                        {...field}
                    />
                )}
            />
            <InformationForPersonalData>
                Para mais informações sobre o tratamento de dados pessoais, acesse o nosso{" "}
                <PrivacyPortal href="https://csh.my.site.com/portalprivacidade/s/" target="_blank">Portal de Privacidade.</PrivacyPortal>
            </InformationForPersonalData>
            {(errors?.CorrectData?.message || errors?.AwareInformation?.message) &&
                <ErrorMessage>
                    <IconError />
                    Para prosseguir, é preciso que você aceite as duas opções apresentadas.
                </ErrorMessage>
            }
        </CheckBoxComboContainer>
    )
}

export default CheckBoxCombo